module.exports = __webpack_public_path__ + "img/map_arrow (2).13eb6dcf.png";